/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_Name_LabelInputs */

const vi_shop_category_name_label = /** @type {(inputs: Shop_Category_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên danh mục`)
};

/**

* @param {Shop_Category_Name_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_name_label = /** @type {((inputs?: Shop_Category_Name_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_Name_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_name_label(inputs)
});